import cls from './NavButton.module.scss'
import { Link, useNavigate } from 'react-router-dom'
import { classNames } from 'shared/lib/classNames/classNames'
import { useRef } from 'react'

const DUPLICATE_TOUCH_CLICK_WINDOW_MS = 700

export const NavButton = (props) => {
    const { to, title, icon: Icon, location, newContent, onActive } = props
    const navigate = useNavigate()
    const lastTouchNavigationRef = useRef(0)

    let disable
    if (to === location.pathname) {
        disable = cls.Disable
    }

    const onPointerUp = (event) => {
        if (event.pointerType !== 'touch' || to === location.pathname) return

        // Mobile Safari can postpone or cancel the synthetic click after a tap,
        // especially next to a composited scroll container. Navigate on the
        // actual touch release and ignore the compatibility click that follows.
        event.preventDefault()
        lastTouchNavigationRef.current = Date.now()
        onActive?.()
        navigate(to)
    }

    const onClick = (event) => {
        if (
            Date.now() - lastTouchNavigationRef.current <
            DUPLICATE_TOUCH_CLICK_WINDOW_MS
        ) {
            event.preventDefault()
            return
        }

        onActive?.()
    }

    return (
        <Link
            to={to}
            className={classNames(cls.Link, {}, [disable])}
            onPointerUp={onPointerUp}
            onClick={onClick}
        >
            <div
                className={`${cls.Container} ${
                    to === location.pathname ? cls.ActiveContainer : ''
                }`}
            >
                {newContent ? <div className={cls.RedDot} /> : null}
                <Icon className={cls.Image} />
            </div>
            <div className={to === location.pathname ? cls.Active : cls.Title}>
                {title}
            </div>
        </Link>
    )
}
